import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer data-testid="footer" className="bg-white border-t border-gray-300 mt-auto" data-id="element-256">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-257">
        <div data-testid="footer-links" className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-258">
          <div data-testid="footer-company-section" data-id="element-259">
            <h3 className="font-bold text-sm mb-4" data-id="element-260">Company</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-261">
              <li data-id="element-262">
                <Link data-testid="footer-about-link" to="/about" className="hover:text-[#1f2933]" data-id="element-263">
                  About Us
                </Link>
              </li>
              <li data-id="element-264">
                <Link data-testid="footer-contact-link" to="/contact" className="hover:text-[#1f2933]" data-id="element-265">
                  Contact
                </Link>
              </li>
              <li data-id="element-266">
                <Link data-testid="footer-careers-link" to="/careers" className="hover:text-[#1f2933]" data-id="element-267">
                  Careers
                </Link>
              </li>
              <li data-id="element-268">
                <Link data-testid="footer-press-link" to="/press" className="hover:text-[#1f2933]" data-id="element-269">
                  Press
                </Link>
              </li>
            </ul>
          </div>

          <div data-testid="footer-resources-section" data-id="element-270">
            <h3 className="font-bold text-sm mb-4" data-id="element-271">Resources</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-272">
              <li data-id="element-273">
                <Link data-testid="footer-legal-guides-link" to="/legal-guides" className="hover:text-[#1f2933]" data-id="element-274">
                  Legal Guides
                </Link>
              </li>
              <li data-id="element-275">
                <Link data-testid="footer-blog-link" to="/blog" className="hover:text-[#1f2933]" data-id="element-276">
                  Blog
                </Link>
              </li>
              <li data-id="element-277">
                <Link data-testid="footer-faq-link" to="/faq" className="hover:text-[#1f2933]" data-id="element-278">
                  FAQ
                </Link>
              </li>
              <li data-id="element-279">
                <Link data-testid="footer-support-link" to="/support" className="hover:text-[#1f2933]" data-id="element-280">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          <div data-testid="footer-legal-section" data-id="element-281">
            <h3 className="font-bold text-sm mb-4" data-id="element-282">Legal</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-283">
              <li data-id="element-284">
                <Link data-testid="footer-terms-link" to="/terms" className="hover:text-[#1f2933]" data-id="element-285">
                  Terms of Use
                </Link>
              </li>
              <li data-id="element-286">
                <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-[#1f2933]" data-id="element-287">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-288">
                <Link data-testid="footer-accessibility-link" to="/accessibility" className="hover:text-[#1f2933]" data-id="element-289">
                  Accessibility
                </Link>
              </li>
              <li data-id="element-290">
                <Link data-testid="footer-cookies-link" to="/cookies" className="hover:text-[#1f2933]" data-id="element-291">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          <div data-testid="footer-connect-section" data-id="element-292">
            <h3 className="font-bold text-sm mb-4" data-id="element-293">Connect</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-294">
              <li data-id="element-295">
                <a data-testid="footer-twitter-link" href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-296">
                  Twitter
                </a>
              </li>
              <li data-id="element-297">
                <a data-testid="footer-linkedin-link" href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-298">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-299">
                <a data-testid="footer-facebook-link" href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-300">
                  Facebook
                </a>
              </li>
              <li data-id="element-301">
                <a data-testid="footer-instagram-link" href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-302">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div data-testid="footer-bottom" className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-303">
          <div className="flex items-center gap-2" data-id="element-304">
            <div className="w-6 h-6 bg-[#1f2933] rounded-sm" data-id="element-305"></div>
            <span className="font-bold" data-id="element-306">Citiplots.com</span>
          </div>
          <p data-testid="footer-copyright" className="text-xs text-gray-500 font-mono" data-id="element-307">
            © {new Date().getFullYear()} Citiplots Private Limited. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}